import { render, staticRenderFns } from "./lab_area_sel.vue?vue&type=template&id=6e683a02&scoped=true"
import script from "./lab_area_sel.vue?vue&type=script&lang=js"
export * from "./lab_area_sel.vue?vue&type=script&lang=js"
import style0 from "./lab_area_sel.vue?vue&type=style&index=0&id=6e683a02&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e683a02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e683a02')) {
      api.createRecord('6e683a02', component.options)
    } else {
      api.reload('6e683a02', component.options)
    }
    module.hot.accept("./lab_area_sel.vue?vue&type=template&id=6e683a02&scoped=true", function () {
      api.rerender('6e683a02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/org/lab_area_sel.vue"
export default component.exports